import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import Card from "components/Card/Card.js";
import CardAvatar from 'components/Card/CardAvatar';
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from 'components/CustomButtons/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import moment from 'moment';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Nav from 'react-bootstrap/Nav';
import BackButton from 'components/BackButton'
import { apiRequest } from 'util/api/util'
import ReactTable from "react-table";
import EmailIcon from '@material-ui/icons/Email';
import ShareButton from 'components/ShareButton'
import ReactDOM from 'react-dom'
import UserButton from "./CustomButtons/UserButton";
import {CSVDownload} from 'react-csv';

const useStyles = makeStyles(styles);

function PurchasesTable({isLoading, purchases}) {

    

    const data = purchases.map(val => {

        var nameConstructed = ""
        if (val?.user?.firstName) {
            nameConstructed = val.user.firstName
        }
        if (val?.user?.lastName) {
            nameConstructed = nameConstructed + " " + val.user.lastName
        }
        const NOW = moment().unix()
        const ONEYEAR = moment().add(1,'y').unix()
        const expirationDate = moment(val.expires * 1000)
        return {
            userId: val.userId,
            buttonToUser: val?.user ? (<UserButton 
                user={val.user}
                />) : nameConstructed,
            name: nameConstructed,
            email: val.user.email,
            created: val.created,
            canceled: val.canceled,

            datePurchased: moment(val.created * 1000).format("LLLL"),
            purchasedDate: moment(val.created*1000).format("MM/DD/YYYY h:mm:ss a"),
            expiresDate: moment(val.expires*1000).format("MM/DD/YYYY h:mm:ss a"),
            expires: val.expires,
            amountRemaining: val.remaining,
            remaining: val?.offering?.type === "pack" ? (
            <>
                <span>{val.remaining}</span><br></br>
                { val.expires < ONEYEAR && (
                    <span>
                        {`${val.expires > NOW ? "Expires" : "Expired"} ${expirationDate.format("LL")}`}
                    </span>
                )}
            </>
            ) : (
            <>
                {val.canceled ? `${val.expires > NOW ? "Expires" : "Expired"}` : "Renews"}&nbsp;{expirationDate.format("LLLL")}
            </>
            ),
            id: (
                <div className="d-flex d-row align-items-center">
                    <input
                    style={{paddingRight: "50px"}}
                    type="text" value={val.user.platformID} readOnly={true} className={"form-control"}/>
                    <ShareButton link={val.user.platformID}
                    style={{marginLeft: "-50px"}}
                    />
                    
                </div>
            ),
            actions: (
                // we've added some custom button actions
                <div className="actions-right">
                  <Button
                    justIcon
                    round
                    simple
                    onClick={() => {
                      window.location.href = `mailto:${val?.user?.email}`
                    }}
                    color="info"
                    className="like"
                  >
                    <EmailIcon />
                  </Button>{" "}
                </div>
              )
        }
    })

    function handleExport() {
        const headers = [
          
            {label: "Client Name", key: "name"},
            {label: "Client Email", key: "email"},
            {label: "User ID", key: "userId"},
            {label: "Date Purchased", key: "purchasedDate"},
            {label: "Renewal / Epiration", key: "expiresDate"},
            {label: "R / E Timestamp", key: "expires"},
            {label: "Cancled", key: "canceled"},
            {label: "Remaining", key: "amountRemaining"}
        ]

        const element = (<CSVDownload filename={`export-purchases.csv`} data={data} headers={headers} target="_blank" />);
 
        ReactDOM.render(element, document.querySelector('#export-offerings-div'));
    }


    return (
    <div>
        <div className="d-flex flex-row-reverse">
            <Button onClick={handleExport} size={"sm"}>Export to CSV</Button>
            <div id='export-offerings-div'></div>
        </div>
        <ReactTable
        loading={isLoading}
                data={data}
                filterable
                columns={[
                    {
                        Header: "Name",
                        accessor: "buttonToUser",
                        sort: "desc"
                    },
                    // {
                    // Header: "Name",
                    // accessor: "name",
                    // sort: 'desc'
                    // },
                    {
                    Header: "Email",
                    accessor: "email",
                    sort: 'desc'
                    },
                    {
                    Header: "Date Purchased",
                    accessor: "created",
                    sort: 'desc',
                    Cell: row => (
                        <div>
                            <h6>{moment(row.value * 1000).format("dddd MMM Do")}</h6>
                            <div>{moment(row.value * 1000).format("h:mm a")}</div>
                        </div>
                    ),
                    },
                    {
                    Header: "Remaining",
                    accessor: "remaining",
                    sort: 'desc',
                    },
                    {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                    }
                ]}
                defaultPageSize={10}
                showPaginationTop={false}
                showPaginationBottom={true}
                className="-highlight"
                  />
    </div>
    )
}

function OfferingSection(props) {
    const offeringId = props.match.params.offeringId
    const { history, match } = props;
    const classes = useStyles();

    const [isLoading, setIsLoading] = React.useState(false)
    const [purchases, setPurchases] = React.useState([])

    const selectedOffering = useSelector(state => state.instructor.offerings.filter(val => val.id === offeringId))[0]

    useEffect(() => {
        setIsLoading(true)
        apiRequest(`app/dashboardPurchases?offeringId=${offeringId}`)
            .then(data => {
                setIsLoading(false)
                setPurchases(data)
            })
            .catch(err => {
                setIsLoading(false)
            })

    }, [])
    return (
        <div className="container">
            <BackButton />
            { selectedOffering && (
                <GridContainer>
                <GridItem xs={12}>
                    <Card>
                    <CardHeader className="d-flex d-row align-items-center">
                        <div>
                        <h2 className="font-weight-bold">{selectedOffering.name}</h2>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <PurchasesTable isLoading={isLoading} purchases={purchases} />
                    </CardBody>
                    </Card>
                </GridItem>
                </GridContainer>
            )}
        </div>
    );
}

export default OfferingSection;
